<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="container mt-4" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col my-2" >
                <template #default>   <m-a v-bind='{...{"href":"{\"name\":\"SiteInfo\",\"params\":{}}","target":"_self"},...{}}' :style='""' class="btn btn-primary  w-100 rounded-pill" >
                <template #default>بارهای اطراف من   </template>
                </m-a></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-lg-3 my-2" >
                <template #default>   <m-location-1 v-bind='{...{},...{}}' :style='""' class="col-12" ></m-location-1></template>
                </m-div></template>
                </m-div></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class=" my-3" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="container" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row  align-items-center" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-12  mb-3" >
                <template #default>   <m-filter-feature-2 v-bind='{...{"featuresId":["3","21"],"filterRoute":"Products"},...{}}' :style='""' class="" ></m-filter-feature-2></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div><m-products-304 v-bind='{...{"perPage":15,"productCardName":"mProductCard3_1","cardCLass":"my-1","cardWrapperCLass":"col-lg-4 archive-parent-item","offerType":"number","offerStatus":true,"productBrandProp":true,"productSearchProp":true,"productQuantityProp":true,"productFeatureProp":true,"productFeaturePanelOpenCloseProp":false,"productCategoryProp":false,"productStoresProp":true,"productSortProp":true,"relatedCurrentCategory":true,"productPriceFilterProp":true,"cardLinkType":"_blank","showKeywords":false,"smCardName":"mProductCard3_1","dashboardProduct":false,"publishStatusFilter":false,"image":null,"alt":"mix it web","cardLink":true},...{}}' :style='""' class="product-archive-304 mb-5 pb-5" ></m-products-304><m-filter-with-link-1 v-bind='{...{"pageName":"Products","features":["\u0646\u0627\u0648\u06af\u0627\u0646","\u0628\u0627\u0631 \u062f\u0631\u062c\u0627 \u062e\u0627\u0644\u06cc","\u0635\u0627\u0641\u06cc","\u0648\u0636\u0639\u06cc\u062a \u0628\u0627\u0631","\u062a\u0627\u0631\u06cc\u062e \u0628\u0627\u0631\u06af\u06cc\u0631\u06cc"]},...{}}' :style='"bottom: 5rem;  position: fixed; bottom:5rem; "' class="filter-modal " ></m-filter-with-link-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mA from '@moeinmdn/miw-alpha-components/src/package/Tags/A'; import mLocation1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Location/Location1'; import mFilterFeature2 from '@moeinmdn/miw-alpha-components/src/package/Feature/Filter/FilterFeature2/FilterFeature2'; import mProducts304 from '@moeinmdn/miw-alpha-components/src/package/Product/Products/Products304/Products304'; import mFilterWithLink1 from '@moeinmdn/miw-alpha-components/src/package/Product/Filter/FilterWithLink1/FilterWithLink1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mA,mLocation1,mFilterFeature2,mProducts304,mFilterWithLink1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
